import React from "react";
import {
  useDeleteDayoffTypesMutation,
  useFetchGetDayoffTypesQuery,
} from "../../../store";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import ManagementToolbar from "../managementShared/ManagementToolbar";
import { columns } from "./utils/columns";
import { useDispatch, useSelector } from "react-redux";
import {
  closeDialog,
  openDialog,
} from "../../../store/slices/dialog/dialogSlice";
import {
  CONFIRM_DIALOG,
  DAYOFF_TYPE_DIALOG,
} from "../../../store/slices/utils/dialogEnum";
import { setDayoffType } from "../../../store/slices/applicationManagement/managementSlice";
import CustomConfirmDialog from "../../../components/shared/CustomConfirmDialog";
import {
  openErrorToast,
  openSuccessToast,
} from "../../../store/slices/toast/toastSlice";
import DayoffTypeForm from "./components/DayoffTypeForm";

const PermissionTypes = () => {
  const dispatch = useDispatch();
  const { dayoffType } = useSelector((state) => state.managementSlice);
  const { dayoffTypeDialogOpen } = useSelector((state) => state.dialogSlice);
  const { data: dayoffs, isLoading: dayoffsLoading } =
    useFetchGetDayoffTypesQuery(
      { page: 1, limit: 100 },
      { refetchOnMountOrArgChange: true }
    );
  const [deleteDayoffType, { isLoading: deleteDayoffLoading }] =
    useDeleteDayoffTypesMutation();

  const handleUpdate = (dayoff) => {
    dispatch(setDayoffType(dayoff));
    dispatch(openDialog(DAYOFF_TYPE_DIALOG));
  };

  const handleDelete = (dayoff) => {
    dispatch(setDayoffType(dayoff));
    dispatch(openDialog(CONFIRM_DIALOG));
  };

  const closeDelete = () => {
    dispatch(setDayoffType(null));
    dispatch(closeDialog(CONFIRM_DIALOG));
  };

  const postDelete = () => {
    deleteDayoffType(dayoffType.id).then((res) => {
      if (res) {
        if (!res.data.isSuccess) {
          dispatch(openErrorToast(res.data.message));
        } else {
          dispatch(openSuccessToast("İşlem Tamamlandı"));
          closeDelete();
        }
      }
    });
  };

  return (
    <Box
      sx={{
        height: 500,
        width: "100%",
        marginTop: 10,
        overflowX: "auto",
        minWidth: { xs: 600, sm: 0 },
        flex: "flex",
        flexDirection: "column",
      }}
    >
      {
        <CustomConfirmDialog
          handleConfirm={postDelete}
          title="İzin Türü Silme Onayı"
          text="Bu izin türünü silmek istediğinize emin misiniz?"
          isLoading={deleteDayoffLoading}
          handleClose={closeDelete}
        />
      }
      {dayoffTypeDialogOpen && <DayoffTypeForm />}
      <DataGrid
        rows={dayoffs?.data || []}
        loading={dayoffsLoading}
        disableColumnMenu
        columns={columns(handleUpdate, handleDelete)}
        pageSizeOptions={[5, 10, 25, 50]}
        disableRowSelectionOnClick
        slots={{
          toolbar: (props) => (
            <ManagementToolbar {...props} dialogType={DAYOFF_TYPE_DIALOG} />
          ),
        }}
        showToolbar
      />
    </Box>
  );
};

export default PermissionTypes;
